// Dependencies
import React from "react";
import { CSSTransition } from 'react-transition-group';
import { CSSTransitionProps } from "react-transition-group/CSSTransition";
import { Portal } from 'react-portal';

// Components
import { MinicartContext } from "../contexts/Minicart";
import SidebarHeader from "./SidebarHeader";
import SidebarEmpty from "./SidebarEmpty";
import SidebarFooter from "./SidebarFooter";
import SidebarItems from "./SidebarItems";
import Overlay from "./Overlay";
import styled, { css } from "styled-components";


const SidebarContentWrapper = styled.div`
	position: relative;
	overflow: auto;
`

const SidebarWrapper = styled.div<any>(({ theme: { general: { transition, ...general }, components } }) => css`
	position: fixed;
	top: 0;
	right: 0;
	z-index: 2147491337;

	display: grid;
	grid-template-rows: 5em auto;

	width: 100%;
	max-width: 25em;
	min-width: 20em;

	top: 0;
	bottom: 0;
	height: 100%;

	background-color: #fff;
	box-shadow: 0 0 1em rgba(#000, .1);
	
	transition: all ${transition.duration} ${transition.timingFunction};
	transform: translateX(100%);

	&.enter {
		& {
				transform: translateX(100%);
		}
		&-active {
				transition: all ${transition.duration} ${transition.timingFunction};
				transform: translateX(0);
		}
		&-done {
				transform: translateX(0);
		}
	}
	
	&.exit {
		& {
				transition: all ${transition.duration} ${transition.timingFunction};
				transform: translateX(0);
		}
		&-active {
				transform: translateX(100%);
		}
	}
`);

const CartSidebar = ({ className }: any) => {
		const { opened, itemsCount, toggleState, theme } = React.useContext( MinicartContext );

		const transitionProps: CSSTransitionProps = React.useMemo(() => ({
			in: opened,
			timeout: Number(theme.general.transition.duration.replace('ms', '')),
		}), [theme.general.transition.duration, opened])
		
		return (<>
			<CSSTransition {...transitionProps}>
				<Portal>
					<SidebarWrapper>
						<SidebarHeader className={`${className}-header`} />
						<SidebarContentWrapper>
							{itemsCount <= 0 && <SidebarEmpty className={`${className}-empty`} />}
							<SidebarItems className={`${className}-items`} />
						</SidebarContentWrapper>
						<SidebarFooter className={`${className}-footer`} />
					</SidebarWrapper>           
					<Overlay
						isPortaled={false}
						isVisible={opened}
						disableScrollWhenVisible={true}
						onClick={() => toggleState('opened', false)}
						className={[`${className}-overlay`]}
					/>
				</Portal>
			</CSSTransition>
		</>) 
}

export default CartSidebar; 